import { Component, OnInit, Input, Inject } from '@angular/core';
import {
    BreakpointState,
    Breakpoints,
    BreakpointObserver
} from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/shared/services/api/api.service';
import { EventEmitterService } from 'src/app/shared/services/events/event-emitter.service';
import { MatDialogUtilsService } from 'src/app/shared/services/matDialogUtils/matDialogUtils.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.less']
})
export class SignupComponent implements OnInit {
    isHandset: boolean;
    userCookie: string;
    user: any;
    error = false;
    errorMsg: string;
    name = '';
    email = '';
    password = '';
    thanksMsg = false;
    @Input() isClose = false;
    hide: boolean = false;

    bpObserver: Observable<BreakpointState> = this.breakpointObserver.observe(
        Breakpoints.Handset
    );

    bpSubscription: Subscription;

    constructor(
        private dialogRef: MatDialogRef<SignupComponent>,
        private apiService: ApiService,
        private eventService: EventEmitterService,
        private breakpointObserver: BreakpointObserver,
        @Inject(MAT_DIALOG_DATA) public data,
        private matDialogUtils: MatDialogUtilsService,
        private location: Location,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.bpSubscription = this.bpObserver.subscribe(
            (handset: BreakpointState) => {
                this.isHandset = handset.matches;
            }
        );
    }

    onDestroy(): void {
        this.bpSubscription.unsubscribe();
    }

    validateForm(email, password) {
        this.error = false;
        if (!email) {
            this.error = true;
            this.errorMsg = 'Email cannot be blank';
        } else if (!password) {
            this.error = true;
            this.errorMsg = 'Password cannot be blank';
        } else if (password.length < 8) {
            this.error = true;
            this.errorMsg = 'Password must contain 8 characters';
        }
        return !this.error;
    }

    handleError(payload: any) {
        this.error = true;
        this.errorMsg = payload.error;
    }

    signup(event, name, email, password) {
        event.preventDefault();
        if (this.validateForm(email, password)) {
            const formData: any = new FormData();
            formData.append('name', name);
            formData.append('email', email);
            formData.append('password', password);
            formData.append('c_password', password);
            this.apiService.signup(formData).subscribe(
                (payload: any) => {
                    if (payload.success) {
                        this.error = false;
                        this.thanksMsg = true;
                        // this.apiService.insertCredits().subscribe(()=>{  });
                        this.eventService.fetchUser(
                            payload.success.token,
                            payload.success.user
                        );
                        this.matDialogUtils.closeDialogs();
                    } else {
                        this.error = true;
                        this.errorMsg = (payload.error && payload.error.name[0]) ? payload.error.name[0]
                            : (payload.error && payload.error.email[0]) ? payload.error.email[0] :
                                'Something went wrong!';
                    }
                },
                (error: any) => {
                    if (error.error.error.email) {
                        this.error = true;
                        this.errorMsg = error.error.error.email[0];
                        return false;
                    } else if (error.error.error.name) {
                        this.error = true;
                        this.errorMsg = error.error.error.name[0];
                        return false;
                    }
                }
            );
        }
    }

    socialSignIn(platform) {
        this.eventService.socialSignIn(platform);
    }

    openSigninDialog() {
        this.dialogRef.close();
        if (this.location.path().includes('design/rooms/')) {

            const diaReg = this.matDialogUtils.openSigninDialog(this.isHandset ? '90%' : '35%', false, true, 'custom-backdrop');
            diaReg.afterClosed().subscribe(res => {
                if (res === 'icon') {
                    this.router.navigate(['/'])
                }
            })
        } else {
            this.matDialogUtils.openSigninDialog(this.isHandset ? '90%' : '35%', this.data.isClose);
        }
    }
    closeDialogs() {

        this.dialogRef.close();
        this.matDialogUtils.closeDialogs();
        this.matDialogUtils.closeClicked = true;
    }
    closeIcon() {

        this.dialogRef.close('icon');
        // this.matDialogUtils.closeDialogs();
        this.matDialogUtils.closeClicked = true;
    }
}
